import { render, staticRenderFns } from "./ConsentLedgerView.vue?vue&type=template&id=2ceec1b9&scoped=true&"
import script from "./ConsentLedgerView.vue?vue&type=script&lang=js&"
export * from "./ConsentLedgerView.vue?vue&type=script&lang=js&"
import style0 from "./ConsentLedgerView.vue?vue&type=style&index=0&id=2ceec1b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceec1b9",
  null
  
)

export default component.exports